import { apiClient } from 'pobble-components/dist/api'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { useMe } from 'pobble-components/dist/pobble-user'
import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'

const StarRating = injectSheet({
  rate: {
    display: 'flex',
    gap: '4px',
    flexDirection: 'row-reverse',
    height: '46px',
    padding: '0 10px',
    alignItems: 'flex-end',
    '&:not(:checked) > input': {
      opacity: '0',
      width: '1px',
      height: '1px'
    },
    '&:not(:checked) > label:hover': {
      color: 'var(--yellow)'
    },
    '&:not(:checked) > label:hover ~ label': {
      color: 'var(--yellow)'
    },
    '&:not(:checked) > label': {
      float: 'right',
      width: '1em',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      fontSize: '30px',
      lineHeight: '1.2',
      color: '#ccc',
      '&:before': {
        content: '"★"'
      }
    },
    '& > input:checked ~ label': {
      color: 'var(--yellow)'
    },
    '& > input:checked + label:hover, > input:checked + label:hover ~ label, > input:checked ~ label:hover, > input:checked ~ label:hover ~ label, > label:hover ~ input:checked ~ label': {
      color: 'var(--yellow)'
    }
  },
  readOnly: {
    '&:not(:checked) > label': {
      color: '#333 !important',
      cursor: 'default'
    },
    '& > input:checked ~ label': {
      color: 'var(--yellow) !important'
    },
    '& > input:checked + label:hover, > input:checked + label:hover ~ label, > input:checked ~ label:hover, > input:checked ~ label:hover ~ label, > label:hover ~ input:checked ~ label': {
      color: 'var(--yellow) !important'
    }
  }
})(({ classes, name, onChange, value, readOnly }) => {
  return (
    <div className={`${classes.rate} ${readOnly ? classes.readOnly : ''}`}>
      <input
        required
        checked={value === 5}
        onChange={onChange}
        type="radio"
        id={`${name}_star_1`}
        name={name}
        value={5}
      />
      <label htmlFor={`${name}_star_1`} title="text">
        5 stars
      </label>
      <input
        checked={value === 4}
        onChange={onChange}
        type="radio"
        id={`${name}_star_2`}
        name={name}
        value={4}
      />
      <label htmlFor={`${name}_star_2`} title="text">
        4 stars
      </label>
      <input
        checked={value === 3}
        onChange={onChange}
        type="radio"
        id={`${name}_star_3`}
        name={name}
        value={3}
      />
      <label htmlFor={`${name}_star_3`} title="text">
        3 stars
      </label>
      <input
        checked={value === 2}
        onChange={onChange}
        type="radio"
        id={`${name}_star_4`}
        name={name}
        value={2}
      />
      <label htmlFor={`${name}_star_4`} title="text">
        2 stars
      </label>
      <input
        checked={value === 1}
        onChange={onChange}
        type="radio"
        id={`${name}_star_5`}
        name={name}
        value={1}
      />
      <label htmlFor={`${name}_star_5`} title="text">
        1 star
      </label>
    </div>
  )
})

export const RateLessonCTA = injectSheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#fff',
    padding: '48px 0',
    gap: '24px',
    textAlign: 'center',
    font: 'var(--body)',
    '& p': {
      margin: '0'
    },
    '& header': {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    '& form': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      '& section': {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }
    }
  },
  feedback: {
    border: 'none',
    borderRadius: '8px',
    background: '#222',
    color: '#fff',
    padding: '16px',
    width: '280px',
    height: '100px',
    marginTop: '4px',
    display: 'block'
  },
  submit: {
    marginTop: '16px'
  },
  hint: {
    font: 'var(--body-)',
    color: 'var(--gray---)'
  },
  lastEntries: {
    display: 'flex',
    listStyle: 'none',
    width: '340px',
    margin: '0 auto',
    flexDirection: 'column',
    textAlign: 'left',
    marginTop: '32px',
    gap: '24px',
    '& p': {
      color: 'var(--gray---)'
    }
  },
  initial: {
    marginTop: '-16px'
  }
})(({ classes, id }) => {
  const { me } = useMe()
  const [imageRating, setImageRating] = useState(null)
  const [activitiesRating, setActivitiesRating] = useState(null)
  const [feedback, setFeedback] = useState('')
  const [myRating, setMyRating] = useState('pending')
  const [communityRating, setCommunityRating] = useState('pending')
  const [submitting, setSubmitting] = useState(false)
  const isPobbler = !!me.account.pobbler_type
  const [latestEntries, setLatestEntries] = useState(null)

  useEffect(
    () => {
      apiClient
        .get(`v3/me/presentations/${id}/my_rating`)
        .then(res => setMyRating(res.data.rating))
        .catch(errorHandler)
      apiClient
        .get(`v3/presentations/${id}/rating`)
        .then(res => setCommunityRating(res.data.rating))
        .catch(errorHandler)
    },
    [id]
  )

  useEffect(
    () => {
      if (isPobbler) {
        apiClient
          .get(`v3/presentations/${id}/last_ratings`, {
            params: {
              number_of_ratings: 10
            }
          })
          .then(res => setLatestEntries(res.data.last_ratings))
      }
    },
    [id, isPobbler]
  )

  return myRating === 'pending' ||
    communityRating === 'pending' ? null : !!myRating || isPobbler ? (
    <section className={classes.container}>
      <header>
        <p>
          <strong>Community rating</strong>
        </p>
        {communityRating.number_of_ratings > 1 && (
          <p className={classes.hint}>
            based on {communityRating?.number_of_ratings} reviews
          </p>
        )}
      </header>
      <section>
        <p>Image</p>
        <StarRating
          readOnly
          value={Math.round(communityRating?.image)}
          name="picture"
        />
      </section>
      <section>
        <p>Activities</p>
        <StarRating
          readOnly
          value={Math.round(communityRating?.activities)}
          name="activities"
        />
      </section>
      {latestEntries && (
        <ul className={classes.lastEntries}>
          {latestEntries.map((entry, index) => {
            return (
              <li key={index}>
                <p>
                  Image: {entry.image}, Activities: {entry.activities}
                </p>
                {entry.feedback}
              </li>
            )
          })}
        </ul>
      )}
    </section>
  ) : (
    <section className={classes.container}>
      <header>
        <p>Do you like this lesson?</p>
      </header>
      {!imageRating && !activitiesRating ? (
        <div className={classes.initial}>
          <StarRating
            onChange={e => {
              setImageRating(parseInt(e.target.value))
              setActivitiesRating(parseInt(e.target.value))
            }}
          />
        </div>
      ) : (
        <form
          onSubmit={e => {
            e.preventDefault()
            setSubmitting(true)
            apiClient
              .post(`v3/me/presentations/${id}/rate`, {
                image: imageRating,
                activities: activitiesRating,
                feedback
              })
              .then(() => {
                apiClient
                  .get(`v3/presentations/${id}/rating`)
                  .then(res => {
                    setCommunityRating(res.data.rating)
                    setMyRating({
                      image: imageRating,
                      activities: activitiesRating
                    })
                  })
                  .catch(errorHandler)
              })
              .catch(errorHandler)
          }}>
          <section>
            <p>Rate the image</p>
            <StarRating
              value={imageRating}
              onChange={e => setImageRating(parseInt(e.target.value))}
              name="picture"
            />
          </section>
          <section>
            <p>Rate activities</p>
            <StarRating
              value={activitiesRating}
              onChange={e => setActivitiesRating(parseInt(e.target.value))}
              name="activities"
            />
          </section>
          <section>
            <label htmlFor="rating_feedback">Feedback (optional)</label>
            <textarea
              value={feedback}
              onChange={e => setFeedback(e.target.value)}
              className={classes.feedback}
              id="rating_feedback"
            />
          </section>
          <Button
            pending={submitting}
            white
            className={classes.submit}
            type="submit"
            tall>
            Submit to see community rating
          </Button>
        </form>
      )}
    </section>
  )
})
